import React from 'react';
import NewPage from '../components/NewPage';
import ProfileContainer from '../containers/profile/ProfileContainer';

const ProfilePage = () => {
  return (
    <NewPage title="정보 수정">
      <ProfileContainer />
    </NewPage>
  );
};

export default ProfilePage;
